<div class="ui-phone-input">
  <div class="ui-phone-input__header">
    <label class="ui-phone-input__label" [attr.for]="inputId()">{{ label() }}</label>
    @if (showRequirement()) {
      <span
        class="ui-phone-input__requirement"
        [class.ui-phone-input__requirement--error]="invalid() && required()"
        aria-hidden="true"
      >
        {{ requirementText() }}
      </span>
    }
  </div>

  <div
    class="ui-phone-input__field"
    [class.ui-phone-input__field--invalid]="invalid()"
    [class.ui-phone-input__field--disabled]="disabled()"
    [class.ui-phone-input__field--open]="ladaOpen()"
  >
    <!-- Trigger de lada (dropdown custom) -->
    <button
      #ladaTrigger
      type="button"
      class="ui-phone-input__lada-trigger"
      [class.ui-phone-input__lada-trigger--open]="ladaOpen()"
      [disabled]="disabled()"
      [attr.aria-haspopup]="'listbox'"
      [attr.aria-expanded]="ladaOpen()"
      [attr.aria-controls]="ladaPanelId()"
      (click)="toggleLada()"
    >
      <span class="ui-phone-input__lada-code">{{ callingCode() }}</span>
      <span
        class="ui-phone-input__lada-chevron"
        [class.ui-phone-input__lada-chevron--open]="ladaOpen()"
        aria-hidden="true"
      >
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
          <path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </button>

    <span class="ui-phone-input__divider" aria-hidden="true"></span>

    <!-- Input del número -->
    <input
      class="ui-phone-input__number"
      type="tel"
      inputmode="tel"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.placeholder]="placeholder()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      [value]="phoneNumber()"
      (input)="onNumberInput($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />
  </div>

  <!-- Panel del dropdown de lada (position:fixed) -->
  @if (ladaOpen() && panelRect()) {
    <div
      class="ui-phone-input__lada-panel"
      [id]="ladaPanelId()"
      role="listbox"
      aria-label="Código de país"
      [style.top.px]="panelRect()!.top"
      [style.left.px]="panelRect()!.left"
      [style.width.px]="panelRect()!.width"
    >
      <!-- Búsqueda -->
      <div class="ui-phone-input__lada-search-wrap">
        <span class="ui-phone-input__lada-search-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M10.5 10.5L14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </span>
        <input
          #ladaSearch
          class="ui-phone-input__lada-search-input"
          type="text"
          placeholder="Buscar..."
          [ngModel]="ladaSearch_()"
          (ngModelChange)="onSearchChange($event)"
          (click)="$event.stopPropagation()"
          autocomplete="off"
        />
      </div>

      <!-- Lista de ladas -->
      <ul class="ui-phone-input__lada-list" role="presentation">
        @for (c of filteredCodes(); track c.code) {
          <li
            class="ui-phone-input__lada-option"
            role="option"
            [class.ui-phone-input__lada-option--selected]="c.code === callingCode()"
            [attr.aria-selected]="c.code === callingCode()"
            (click)="selectCode(c.code)"
          >
            <span class="ui-phone-input__lada-option-code">{{ c.code }}</span>
            <span class="ui-phone-input__lada-option-label">{{ c.label }}</span>
            @if (c.code === callingCode()) {
              <span class="ui-phone-input__lada-option-check" aria-hidden="true">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7l4 4 6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            }
          </li>
        } @empty {
          <li class="ui-phone-input__lada-empty" role="option" aria-disabled="true">Sin resultados</li>
        }
      </ul>
    </div>
  }

  @if (message() && invalid() && showMessage()) {
    <p
      class="ui-phone-input__message ui-phone-input__message--error"
      [id]="messageId()"
      role="alert"
    >
      {{ message() }}
    </p>
  }
</div>
